import {observer, pluralize, React, toJS} from '@api'
import {useStores} from '@modules'
import * as css from './DragImagesPlaceholder.css'

export const DragImagesPlaceholder = observer(function DragImagesPlaceholder() {
  const {dragDrop: {dragImageURIs}, catalog} = useStores()
  if (dragImageURIs.length < 2) return null

  return (<div className={css.root}>
    <div className={css.images} data-images={dragImageURIs.length}>
      {_.take(dragImageURIs, 20).map((uri, i) => <img className={css.image} key={i} src={uri.imageDataUrl} style={{'--index': i} as any} />)}
    </div>
    <label className={css.imageCount}>{dragImageURIs.length} {pluralize(catalog.catalogItemName)}</label>
  </div>)
})


// WEBPACK FOOTER //
// ./src/stores/dragDrop/DragImagesPlaceholder.tsx